const LOCAL_API_PORT = process.env.GATSBY_LOCAL_API_PORT
const CONFIG_TYPE = process.env.GATSBY_CONFIG_TYPE
const NODE_ENV = process.env.NODE_ENV

if (CONFIG_TYPE === "production") {
  console.warn(
    "You are using the production config while in development mode.",
    "Be careful as this means any actions taken will potentially affect real users"
  )
}

const DEV_KEYS = {
  NODE_ENV,
  STRIPE: {
    CONNECT_ID: "ca_G4p5oYqyVNRuSDNnmshU1tNrDFhDJq32",
    PUBLISHABLE_KEY: "pk_test_n9tjJEubxNW0MnA4zQJKPOx900DMDO4Rnq",
  },
  REST_API: {
    BASE_URL: LOCAL_API_PORT
      ? `http://localhost:${LOCAL_API_PORT}/itty-3dfb2/us-central1/api`
      : `https://us-central1-itty-3dfb2.cloudfunctions.net/api`,
  },
  FIREBASE: {
    apiKey: "AIzaSyDQ-lDnFNlEi2y3pcG21Jxmim78mDhtTyg",
    authDomain: "auth.itty.me",
    databaseURL: "https://itty-3dfb2.firebaseio.com",
    projectId: "itty-3dfb2",
    storageBucket: "itty-3dfb2.appspot.com",
    messagingSenderId: "613127265470",
    appId: "1:613127265470:web:cdb21b0224e8a26674d2ef",
    measurementId: "G-J1CXVKWVTK",
  },
  TWILIO: {
    API_KEY: "ACfb319d2f6295f13d70c45332ba2a04ff",
  },
  UPLOADCARE: {
    API_KEY: "7e41dc34106dff2854bc",
    CDN: "",
  },
}

const PROD_KEYS = {
  ...DEV_KEYS,
  STRIPE: {
    CONNECT_ID: "ca_G4p5oYqyVNRuSDNnmshU1tNrDFhDJq32",
    PUBLISHABLE_KEY: "pk_live_LT1og2DoT2zwTlYbcCkXw5RS00DXSqKu9d",
  },
}

const keys =
  NODE_ENV === "production" || CONFIG_TYPE === "production"
    ? PROD_KEYS
    : DEV_KEYS

if (NODE_ENV !== "production") {
  console.groupCollapsed("Config Keys")
  console.log(keys)
  console.groupEnd()
}

export default keys
